import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { DASHBOARD_TYPE } from "../utils/enums";
import { Constants } from "../utils";
import { queryClient } from "../lib/queryClient";

const storeName = `@BOLLE`;

const usePersistStore = create(
  persist(
    (set) => ({
      token: "",
      setToken: (t: string) => set({ token: t }),
      user: null,
      setUser: (t: any) => set({ user: t }),
      adInProgress: null,
      setAdInProgress: (t: any) => set({ adInProgress: t }),
      dashboardType: DASHBOARD_TYPE.BUYER,
      setDashboardType: (t: string) => set({ dashboardType: t }),
      watchlist: [],
      setWatchlist: (t: string[]) => set({ watchlist: t }),
      following: [],
      setFollowing: (t: string[]) => set({ following: t }),
      followers: [],
      setFollowers: (t: string[]) => set({ followers: t }),
      currentLocation: [0, 0],
      setCurrentLocation: (s: number[]) => {
        set({ currentLocation: s });
      },
      isVerifiedUser: true,
      setIsVerifiedUser: (t: boolean) => {
        set({ isVerifiedUser: t });
      },
      isBuyerProfileCompleted: true,
      setIsBuyerProfileCompleted: (t: boolean) => {
        set({ isBuyerProfileCompleted: t });
      },
      logout: () => {
        // Clear cached queries so no data leaks into the next session.
        queryClient.clear();
        set(
          () => ({
            token: "",
            user: null,
            adInProgress: null,
            dashboardType: DASHBOARD_TYPE.BUYER,
            watchlist: null,
            following: [],
            followers: [],
            isVerifiedUser: false,
            isBuyerProfileCompleted: false,
            currentLocation: [0, 0],
          }),
          true,
        );
      },
    }),
    {
      name: storeName,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

const useStore = create((set) => ({
  isLoading: false,
  setIsLoading: (t: boolean) => {
    set(() => ({ isLoading: t }));
  },
  isUploading: false,
  setIsUploading: (t: boolean) => {
    set(() => ({ isUploading: t }));
  },
  isFromPrelaunch: false,
  setIsFromPrelaunch: (t: boolean) => {
    set(() => ({ isFromPrelaunch: t }));
  },
  errorMessage: "",
  setErrorMessage: (e: string) => {
    set({ errorMessage: e });
  },
  successMessage: "",
  setSuccessMessage: (s: string) => {
    set({ successMessage: s });
  },
  infoMessage: "",
  setInfoMessage: (s: string) => {
    set({ infoMessage: s });
  },
  quickSuccessMessage: "",
  setQuickSuccessMessage: (s: string) => {
    set({ quickSuccessMessage: s });
  },
  keyword: "",
  setKeyword: (s: string) => {
    set({ keyword: s });
  },
  priceRange: Constants.PRICE_RANGE,
  setPriceRange: (s: any) => {
    set({ priceRange: s });
  },
  mediumIds: [] as string[],
  setMediumIds: (s: string[]) => {
    set({ mediumIds: s });
  },
  radius: Constants.SEARCH_MAX_RADIUS,
  setRadius: (s: number) => {
    set({ radius: s });
  },
  resetFilters: () => {
    set({
      keyword: "",
      priceRange: Constants.PRICE_RANGE,
      mediumIds: [],
      radius: Constants.SEARCH_MAX_RADIUS,
    });
  },
  isGoogleSignup: false,
  setIsGoogleSignup: (t: boolean) => {
    set({ isGoogleSignup: t });
  },
}));

export { useStore, usePersistStore };
